<div *ngIf="cmdbCluster">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>hub</mat-icon>
      {{
        cmdbCluster.id ? "Cluster - " + cmdbCluster.name : "Create new Cluster"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="validatingCompany || companyValidationFailed || !form.form.valid || !cmdbCluster.platformId || !cmdbCluster.companyId"
      >
        <mat-icon>{{ cmdbCluster.id ? "save" : "add" }}</mat-icon>
        {{ cmdbCluster.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="cmdbCluster.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <p *ngIf="companyValidationFailed">
      Unable to validate the selected platform for this company.
      <button mat-button type="button" (click)="validateCompanySelections()">Retry</button>
    </p>
    <form #form="ngForm" role="form" style="margin-bottom: 1em;">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">Cluster Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [companyId]="cmdbCluster.companyId" (companyIdChange)="onCompanyChange($event)" [required]="true"></micro-company-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="Cluster Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="cmdbCluster.name"
                required
                maxlength="50"
                id="name"
                name="name"
              />
            </td>
          </tr>
          <tr>
            <th>Platform</th>
            <td><micro-select-pagination apiUrl="/domain/cmdbHostingPlatform" [(id)]="cmdbCluster.platformId" [defaultOption]="selectedPlatform" (objectChange)="selectedPlatform = $event" placeholder="Platform" routerBase="hostingPlatforms" [params]="{companyId: cmdbCluster.companyId}" [disabled]="validatingCompany || !cmdbCluster.companyId" [required]="true"></micro-select-pagination></td>
          </tr>
          <tr>
            <th>Description</th>
            <td>
              <textarea
                [(ngModel)]="cmdbCluster.description"
                required
                maxlength="200"
                id="description"
                name="description"
                style="min-width: 350px; min-height: 100px;"
              ></textarea>
            </td>
          </tr>
          <tr>
            <th [ngClass]="cmdbCluster.active !== 'Y' ? 'CRITICAL' : ''">
              <micro-valid-label
                for="active"
                label="Active"
              ></micro-valid-label>
            </th>
            <td>
              <input type="checkbox" [checked]="cmdbCluster.active === 'Y'" (change)="onCheckboxChange($event)" id="active" name="active">
            </td>
          </tr>
        </tbody>
      </table>
    </form>
    <micro-cmdb-cluster-nes *ngIf="cmdbCluster.id" [clusterId]="cmdbCluster.id" ></micro-cmdb-cluster-nes>
  </div>
</div>
